// Services
import ObjectHelperService from './object-helper.service';

export default {
  filterPropertiesByArray(json, filterArray) {
    /*
        Expected Input:
          [Array of Objects]
          json = [{
            [Any Data Type]
            key: value,
          }]

          [Array of Strings]
          filterArray = [
            [Property Name String]
            String
          ]

        Expected Output:
          A filtered JSON Object that has properties corresponding to the elements given in `filterArray`.
    */

    // Check for empty JSON
    if (ObjectHelperService.isArrayEmpty(json)) {
      return json;
    }

    // Return a remapped JSON object that contains matched properties of `filterArray`.
    return json.map(object => {
      const objectMap = {};

      Object.keys(object).forEach(property => {
        if (filterArray.some(element => element === property)) {
          objectMap[property] = object[property];
        }
      });

      return objectMap;
    });
  }
};
